import moduleAbilities from "@/composables/moduleAbilities";
import abilities from "@/composables/abilities";

export default {
    /*
    |--------------------------------------------------------------------------
    | Finances Routes
    |--------------------------------------------------------------------------|
    */

    path: 'financials',
    name: 'financials',
    children: [
        /*
        |--------------------------------------------------------------------------
        | Expenses Routes
        |--------------------------------------------------------------------------|
        */
        {
            path: 'accounting',
            children: [
                {
                    path: '',
                    component: () => import('@/Modules/Financial/views/Accounting/ExpenseSummaryStats'),
                    name: 'expenses-summary-stats',
                    meta: {  requiresPermission: abilities.VIEW_EXPENSE,requiresAccess: [moduleAbilities.FINANCE_EXPENSE]},
                },
                {
                    path: ':company/office/:id/users/expenses/overview',
                    component: () => import('@/Modules/Financial/views/Accounting/OfficeUserExpenseOverview.vue'),
                    name: 'office-users-expenses-overview',
                    meta: {  requiresPermission: abilities.VIEW_OFFICE_EXPENSE,requiresAccess: [moduleAbilities.FINANCE_EXPENSE]},
                },
                {
                    path: ':company/office/:id/expenses/list',
                    component: () => import('@/Modules/Financial/views/Accounting/OfficeExpenseList.vue'),
                    name: 'office-expenses',
                    meta: {  requiresPermission: abilities.VIEW_OFFICE_EXPENSE,requiresAccess: [moduleAbilities.FINANCE_EXPENSE]},
                },
                {
                    path: ':company/office/:office/:id/users/expenses/list',
                    component: () => import('@/Modules/Financial/views/Accounting/OfficeUserExpenseList.vue'),
                    name: 'office-users-expenses-list',
                    meta: {  requiresPermission: abilities.VIEW_OFFICE_EXPENSE,requiresAccess: [moduleAbilities.FINANCE_EXPENSE]},
                },
                {
                    path: 'users/expense/:id/details',
                    component: () => import('@/Modules/Financial/views/Accounting/ExpenseDetails.vue'),
                    name: 'office-user-expense-details',
                    meta: {  requiresPermission: abilities.VIEW_EXPENSE,requiresAccess: [moduleAbilities.FINANCE_EXPENSE]},
                },
                {
                    path: ':office/create/recurrence/expense',
                    component:  () => import('@/Modules/Financial/views/Accounting/CreateOrEditRecurrence.vue'),
                    name: 'recurrence-expense-create',
                    meta: { requiresPermission: abilities.VIEW_EXPENSE , requiresAccess: [moduleAbilities.FINANCE_EXPENSE ] },
                },
                {
                    path: 'view/:id/recurrence/expense',
                    component:  () => import('@/Modules/Financial/views/Accounting/ViewRecurrence.vue'),
                    name: 'recurrence-expense-view',
                    meta: { requiresPermission: abilities.VIEW_EXPENSE , requiresAccess: [moduleAbilities.FINANCE_EXPENSE ] },
                },
                {
                    path: 'edit/:id/recurrence/expense',
                    component:  () => import('@/Modules/Financial/views/Accounting/CreateOrEditRecurrence.vue'),
                    name: 'recurrence-expense-edit',
                    meta: { requiresPermission: abilities.VIEW_EXPENSE , requiresAccess: [moduleAbilities.FINANCE_EXPENSE ] },
                },
            ]
        },

        /*
        |--------------------------------------------------------------------------
        | Pipeline Routes
        |--------------------------------------------------------------------------|
        */
        {
            path: 'accounts',
            component: () => import('@/Modules/Financial/views/Accounts/Index.vue'),
            name: 'finances-accounts',
            meta: { requiresPermission: abilities.VIEW_ACCOUNT , requiresAccess: [moduleAbilities.FINANCE_ACCOUNT]},
        },

        /*
        |--------------------------------------------------------------------------
        | Expenses Routes
        |--------------------------------------------------------------------------|
        */
        {
            path: 'expenses',
            children: [
                {
                    path: '',
                    component:  () => import('@/Modules/Financial/views/Expense/Index.vue'),
                    name: 'expenses',
                    meta: { requiresPermission: abilities.VIEW_EXPENSE , requiresAccess: [moduleAbilities.FINANCE_EXPENSE ] },
                },
                {
                    path: 'create/:typeId/:type',
                    component:  () => import('@/Modules/Financial/views/Expense/Detail.vue'),
                    name: 'expenses-create',
                    meta: { requiresPermission: abilities.VIEW_EXPENSE , requiresAccess: [moduleAbilities.FINANCE_EXPENSE ] },
                },
                {
                    path: 'edit/:id',
                    component:  () => import('@/Modules/Financial/views/Expense/Detail.vue'),
                    name: 'expenses-edit',
                    meta: { requiresPermission: abilities.UPDATE_EXPENSE , requiresAccess: [moduleAbilities.FINANCE_EXPENSE ] },
                },
                {
                    path: 'view/:id',
                    component: () => import('@/Modules/Financial/views/Expense/View.vue'),
                    name: 'expenses-view',
                    meta: { requiresPermission: abilities.VIEW_EXPENSE , requiresAccess: [moduleAbilities.FINANCE_EXPENSE ] },

                },
            ]
        },
    ]

}
